import StudentLogin from './components/pages/student/Login'
import AdminLogin from './components/pages/admin/Login'
import { createBrowserRouter } from 'react-router-dom';
import AuthLayout from './components/layouts/AuthLayout';
import Course from './components/pages/student/Course';
import StudentLayout from './components/layouts/StudentLayout';
import Signup from './components/pages/student/Signup';
import Leaderboard from './components/pages/student/LeaderBoard';
import AdminLayout from './components/layouts/AdminLayout';
import Assignments from './components/pages/admin/Assignments';
import Videos from './components/pages/admin/Videos';
import Quizzes from './components/pages/admin/Quizzes';
import AssignmentMarks from './components/pages/admin/AssignmentMarks';


const router = createBrowserRouter([
  {
    path: "/",
    element: <AuthLayout />,
    children: [
      { index: true, element: <StudentLogin /> },
      { path: 'signup', element: <Signup /> },
    ],
  },
  {
    path: "/",
    element: <StudentLayout />,
    children: [
      { path: 'course', element: <Course /> },
      { path: 'leaderboard', element: <Leaderboard /> },
    ]
  },
  {
    path: '/admin',
    element: <AuthLayout />,
    children: [
      { index: true, element: <AdminLogin /> },
    ]
  },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      { path: 'assignments', element: <Assignments/> },
      { path: 'assignment-marks', element: <AssignmentMarks/> },
      { path: 'videos', element: <Videos/> },
      { path: 'quizzes', element: <Quizzes/> },
    ]
  }
]);

export default router;